import React, { useState } from 'react';
import { Breadcrumb, Row, Col, Spin } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
const ProfileSettingsPage = (props) => {
    const navigate = useNavigate();
    const [userName, setUserName] = useState(false)
    const [email, setEmail] = useState(false)
    const [registeredAt, setRegisteredAt] = useState(false)
    React.useEffect(() => {
        let userName = sessionStorage.getItem("userName")
        let email = sessionStorage.getItem("email")
        let registeredAt = sessionStorage.getItem("registeredAt")
        console.log(email)
        setUserName(userName)
        setEmail((email==='null'||email===null)?'--':email)
        setRegisteredAt(registeredAt.substring(0,10)+" "+registeredAt.substring(11,19))
    }, [])
    function onStart() {
        props.setNewKey('developerCenter/settings/profileSettings')
        navigate('/developerCenter/settings/profileSettings')
    }
    function onStartSetPassword() {
        navigate('/developerCenter/settings/setPassword')
    }
    return (
        <div style={{ height: '100%', width: '100%', }}>
            <div style={{ height: '260px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
                {/* 标题头 */}
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>Settings</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>Profile Settings</a></Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ fontSize: '20px', marginTop: '30px', marginLeft: '150px' }}>Profile Settings</div>
                <Row style={{ marginTop: '34px', height: '160px' }}>
                    <Col style={{ marginLeft: '66px' }}>
                        {/* 头像 */}
                        <img src={require('../../../../static/img/icon_settings_head_portrait.png')} style={{ width: '100px', height: '100px' }} />
                    </Col>
                    <Col style={{ marginLeft: '38px' }}>
                        <Row style={{ height: '22px' }}>
                            <Col style={{ width: '100px', textAlign: 'right', fontSize: '14px' }}>
                                用户名：
                            </Col>
                            <Col style={{ fontSize: '14px' }}>
                                { userName}
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '12px', height: '22px' }}>
                            <Col style={{ width: '100px', textAlign: 'right', fontSize: '14px' }}>
                                邮箱地址：
                            </Col>
                            <Col style={{ fontSize: '14px' }}>
                                { email}
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '12px', height: '22px' }}>
                            <Col style={{ width: '100px', textAlign: 'right', fontSize: '14px' }}>
                                注册时间：
                            </Col>
                            <Col style={{ fontSize: '14px' }}>
                                { registeredAt}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>

            <div style={{ height: '394px', padding: '0px', backgroundColor: 'white', borderRadius: '2px', marginTop: '22px' }}>

                <div style={{height: '30px'}}></div>
                <div style={{
                    height: '36px', width: '138px', backgroundColor: '#F2F3F8',
                    borderRadius: '32px', fontSize: '14px', color: '#2657F9', textAlign: 'center',
                    marginLeft: '30px',padding: '0px', display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div>安全设置</div>
                </div>
                <Row style={{ marginTop: '20px', marginLeft: '48px', height: '22px', width: '770px', fontSize: '14px' }}>
                    <Col span={12} style={{ width: '385px', color: 'rgba(0, 0, 0, 0.85)' }}>登陆密码</Col>
                    <Col span={12} style={{ width: '385px', textAlign: 'right', color: 'rgba(38, 87, 249, 0.85)' }}>
                        <a onClick={onStartSetPassword}>
                            修改
                        </a>
                    </Col>
                </Row>
                <div style={{ marginTop: '15px', marginLeft: '48px', color: '#D8D8D8', fontSize: '14px' }}>建议您定期更改密码以保证账户安全</div>
                <div style={{ marginTop: '8px', marginLeft: '48px', height: '1px', width: '770px', backgroundColor: '#D8D8D8' }}></div>

            </div>
        </div>
    );

}

export default ProfileSettingsPage